// Equipment financing math shared by the live calculator (EquipmentCalculator.jsx) and the static table the
// build writes into /equipment-financing-calculator, so the two always agree. Fixed-rate, monthly amortization,
// no fees. Rates are hypothetical inputs, not quotes.
export const EQUIPMENT_RATE_RANGE = [7, 30]; // published APR range used across the site (productFacts.js)
export const EQUIPMENT_TERMS = [24, 36, 48, 60, 72, 84];

export const equipmentPayment = (financed, apr, months) => {
  if (!(financed > 0) || !(months > 0) || !(apr >= 0)) return null;
  const r = apr / 100 / 12;
  return r === 0 ? financed / months : financed * r / (1 - Math.pow(1 + r, -months));
};

// price: equipment cost; downPercent: share paid up front; apr: annual rate %; months: term.
export const equipmentQuote = ({ price, downPercent, apr, months }) => {
  if (!(price > 0) || !(downPercent >= 0) || downPercent >= 100) return null;
  const down = price * downPercent / 100;
  const financed = price - down;
  const payment = equipmentPayment(financed, apr, months);
  if (payment === null) return null;
  const totalPayments = payment * months;
  return { down, financed, payment, totalPayments, interest: totalPayments - financed, allIn: down + totalPayments };
};
